// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-view[data-v-4b9095ce]{height:100%;width:100%;display:flex;flex-grow:1;flex-direction:column;align-content:space-between;position:relative}`, "",{"version":3,"sources":["webpack://./src/views/MainView.vue"],"names":[],"mappings":"AACA,4BACC,WAAA,CACA,UAAA,CACA,YAAA,CACA,WAAA,CACA,qBAAA,CACA,2BAAA,CACA,iBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
